export const convertToPicocuries = (bqm) => {
    const pCiL = bqm / 37;

    const fixed = Math.round(pCiL * 10) / 10;
    const parsedValue = parseFloat(fixed.toFixed(1));

    return parsedValue;
};
